export const formModel = {
    fullName: '',
    mobile: '',
    age: '',
    gender: 0,
}